import React from 'react';
import ReactDOM from 'react-dom';
import { apporigin } from '@academysports/aso-env';
import Loadable from 'react-loadable';
import { get } from 'lodash';

const PxModal = Loadable({
  loader: () => import(/* webpackChunkName: "lazy-pxModal" */ './pxCaptchaModal.component'),
  loading: () => <div />,
});
/* eslint-disable no-underscore-dangle */
let isPXScriptInjected = false;
async function verifyPxCaptcha(data) {
  if (isPXScriptInjected === false) {
    isPXScriptInjected = true;
    const script = document.createElement('script');
    script.src = `${apporigin}${data.blockScript}`;
    document.getElementsByTagName('head')[0].appendChild(script);

    return new Promise(resolve => {
      const pxCaptchaWrapper = document.createElement('div');
      pxCaptchaWrapper.id = 'pxCaptchaWrapper';
      document.body.appendChild(pxCaptchaWrapper);

      window._pxOnCaptchaSuccess = isValid => {
        isPXScriptInjected = false;
        if (isValid) {
          console.log(isValid, 'isValid');
          ReactDOM.unmountComponentAtNode(pxCaptchaWrapper);
          pxCaptchaWrapper.remove();
        } else {
          console.log('OnCaptchaSuccess else condition check');
        }

        delete window._pxOnCaptchaSuccess;
        resolve(true);
      };

      Object.keys(data).forEach(k => {
        window[`_px${k[0].toUpperCase()}${k.substr(1)}`] = data[k];
      });
      ReactDOM.render(
        React.createElement(PxModal, {
          cms: get(window, 'ASOData.uiConfig.cmsGlobal', {}),
        }),
        pxCaptchaWrapper
      );
    });
  }
  return Promise.resolve(false);
}
/* eslint-enable no-underscore-dangle */

export default verifyPxCaptcha;
